// Global state to track which component is active
let activeComponent = null;

// Z-index constants
const Z_INDEX = {
  SEARCH_POPUP: 1010, // Above overlay (1001)
  OVERLAY_QUICK_ADD: 1002,
  QUICK_ADD_MODAL: 1008, // Above cart drawer when both are open
  OVERLAY_CART_DRAWER: 1005,
  OVERLAY_QUICK_ADD_ABOVE_CART: 1005, // Overlay above cart when quick-add is open
  CART_DRAWER: 1007,
  DEFAULT_OVERLAY: 1001, // Above header (z-index: 1000)
  MOBILE_MENU_DRAWER: 1001, // Above header (z-index: 1000)
  MOBILE_MENU_OVERLAY: 1001, // Above header (z-index: 1000)
  MOBILE_SEARCH_DRAWER: 1010, // Above overlay and header
  MOBILE_SEARCH_OVERLAY: 1007, // Above header
  FILTER_DRAWER: 1009, // Above header
  FILTER_DRAWER_OVERLAY: 1008, // Above header
};

// Overlay z-index management
const setOverlayZIndex = (zIndex) => {
  const mainOverlay = document.querySelector(".main__overlay");
  if (mainOverlay) {
    mainOverlay.style.zIndex = zIndex;
  }
};

// Reset overlay z-index to default
const resetOverlayZIndex = () => {
  const mainOverlay = document.querySelector(".main__overlay");
  if (mainOverlay) {
    mainOverlay.style.zIndex = Z_INDEX.DEFAULT_OVERLAY;
  }
};

// Filter drawer functions - define early so they're available
const openFilterDrawer = () => {
  const filterDrawer =
    document.getElementById("collection-filter-drawer") ||
    document.querySelector(".filters-drawer");
  const mainOverlay = document.querySelector(".main__overlay");
  if (!filterDrawer || !mainOverlay) {
    console.warn("Filter drawer or overlay not found", {
      filterDrawer,
      mainOverlay,
    });
    return;
  }

  filterDrawer.classList.add("open");
  document.body.style.overflow = "hidden";
  mainOverlay.classList.add("active");

  // Set overlay z-index for filter drawer
  if (window.setOverlayZIndex) {
    window.setOverlayZIndex(window.Z_INDEX?.FILTER_DRAWER_OVERLAY || 999);
  }

  // Store close handler for removal
  const closeHandler = (e) => {
    if (e.target === mainOverlay) {
      closeFilterDrawer();
    }
  };

  mainOverlay.removeEventListener("click", closeHandler); // Remove any existing
  mainOverlay.addEventListener("click", closeHandler);

  if (typeof window.activeComponent !== "undefined") {
    window.activeComponent = "filter";
  } else {
    activeComponent = "filter";
  }
};

const closeFilterDrawer = () => {
  const filterDrawer =
    document.getElementById("collection-filter-drawer") ||
    document.querySelector(".filters-drawer");
  const mainOverlay = document.querySelector(".main__overlay");
  if (!filterDrawer || !mainOverlay) return;

  filterDrawer.classList.remove("open");
  document.body.style.overflow = "";
  mainOverlay.classList.remove("active");

  // Reset overlay z-index
  if (window.resetOverlayZIndex) {
    window.resetOverlayZIndex();
  }

  // Remove click handler by cloning the overlay (clean way to remove all listeners)
  const closeHandler = (e) => {
    if (e.target === mainOverlay) {
      closeFilterDrawer();
    }
  };
  mainOverlay.removeEventListener("click", closeHandler);

  if (typeof window.activeComponent !== "undefined") {
    window.activeComponent = null;
  } else {
    activeComponent = null;
  }
};

// Make functions available on window immediately
window.openFilterDrawer = openFilterDrawer;
window.closeFilterDrawer = closeFilterDrawer;

document.addEventListener("DOMContentLoaded", () => {
  const header = document.getElementById("main-header");
  // Mobile menu functionality
  const mobileMenuBtn = document.getElementById("mobile-menu-btn");
  const mobileMenuDropdown = document.getElementById("mobile-menu-dropdown");
  const mobileMenuCloseButtons =
    document.querySelectorAll(".close_mobile_menu");

  // Cart Drawer
  const cartDrawer = document.getElementById("CartDrawer");

  // Controlling Main overlay
  const mainOverlay = document.querySelector(".main__overlay");

  // Helper function to close any open submenus
  const closeAllSubmenus = () => {
    const openSubmenus = document.querySelectorAll(
      ".mobile-hidden-menu.show, .mobile-hidden-submenu.show"
    );
    openSubmenus.forEach((submenu) => {
      submenu.classList.remove("show");
    });
  };

  // Open/Close Menu
  const toggleMenu = () => {
    const isOpening = !mobileMenuBtn.classList.contains("active");

    mobileMenuBtn.classList.toggle("active");
    mobileMenuDropdown.classList.toggle("active");

    if (isOpening) {
      if (activeComponent === "cart") closeCartDrawer();

      // Set overlay z-index above header for mobile menu
      setOverlayZIndex(Z_INDEX.MOBILE_MENU_OVERLAY);

      // Add overlay click handler when opening
      mainOverlay.addEventListener("click", toggleMenu);

      // Set active component
      activeComponent = "menu";
    } else {
      // Close any open submenus when closing the drawer
      closeAllSubmenus();

      // Remove overlay click handler when closing
      mainOverlay.removeEventListener("click", toggleMenu);

      // Reset overlay z-index
      resetOverlayZIndex();

      activeComponent = null;
    }

    if (mainOverlay.classList.contains("active")) {
      mainOverlay.classList.remove("active");
    } else {
      mainOverlay.classList.add("active");
    }

    document.body.style.overflow = mobileMenuBtn.classList.contains("active")
      ? "hidden"
      : "";
  };

  // Handle close button clicks - close submenu first if open, otherwise close drawer
  mobileMenuCloseButtons.forEach((closeBtn) => {
    closeBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      // Find the closest submenu parent (could be mobile-hidden-menu or mobile-hidden-submenu)
      const submenu = closeBtn.closest(
        ".mobile-hidden-menu, .mobile-hidden-submenu"
      );
      if (submenu) {
        // Close the submenu this button belongs to
        submenu.classList.remove("show");
      } else {
        // Button is not in a submenu, check if any submenu is open
        const openSubmenus = document.querySelectorAll(
          ".mobile-hidden-menu.show, .mobile-hidden-submenu.show"
        );
        if (openSubmenus.length > 0) {
          // Close the most recently opened submenu (last in DOM order)
          openSubmenus[openSubmenus.length - 1].classList.remove("show");
        } else {
          // No submenu open, close the drawer
          toggleMenu();
        }
      }
    });
  });

  // Keep track of overlay click handler
  let overlayClickHandler = null;

  // Initialize Menu Drawer event listeners
  if (mobileMenuBtn && mobileMenuDropdown) {
    mobileMenuBtn.addEventListener("click", toggleMenu);
  }

  //Open Cart Drawer
  const openCartDrawer = () => {
    if (cartDrawer.classList.contains("open")) return;
    cartDrawer.classList.add("open");
    mainOverlay.classList.add("active");

    // Set overlay z-index above quick-add modal
    setOverlayZIndex(Z_INDEX.OVERLAY_CART_DRAWER);

    if (activeComponent === "menu") toggleMenu();

    activeComponent = "cart";

    if (document.body.overflow != "hidden") {
      document.body.style.overflow = "hidden";
    }

    // Add overlay click handler only once
    if (!overlayClickHandler) {
      overlayClickHandler = (e) => {
        if (e.target === mainOverlay) {
          closeCartDrawer();
        }
      };
      mainOverlay.addEventListener("click", overlayClickHandler);
    }
  };

  //Close Cart Drawer
  const closeCartDrawer = () => {
    if (!cartDrawer.classList.contains("open")) return;
    cartDrawer.classList.remove("open");

    // Check if quick-add modal is still open
    const quickAddModal = document.getElementById("quick-add-modal");
    const isQuickAddOpen =
      quickAddModal && quickAddModal.style.display === "flex";

    if (isQuickAddOpen) {
      // Quick-add is still open, set overlay back to quick-add level
      setOverlayZIndex(Z_INDEX.OVERLAY_QUICK_ADD);
      mainOverlay.classList.add("active"); // Keep overlay active for quick-add
      activeComponent = "quick-add";
    } else {
      // No other popup open, reset overlay
      mainOverlay.classList.remove("active");
      resetOverlayZIndex();
      activeComponent = null;
    }

    document.body.style.overflow = "";

    // Remove overlay click handler
    if (overlayClickHandler) {
      mainOverlay.removeEventListener("click", overlayClickHandler);
      overlayClickHandler = null;
    }
  };

  // Modified escape key handler - handles in priority order
  const handleEscapeKey = (e) => {
    if (e.key === "Escape") {
      // Priority: quick-add > cart drawer > mobile-search > search > others
      const cartDrawer = document.getElementById("CartDrawer");
      const quickAddModal = document.getElementById("quick-add-modal");
      const isQuickAddOpen =
        quickAddModal && quickAddModal.classList.contains("open");
      const isCartOpen = cartDrawer && cartDrawer.classList.contains("open");

      // If quick-add is open, close it first (even if cart is open)
      if (isQuickAddOpen) {
        if (
          window.quickAddModal &&
          typeof window.quickAddModal.close === "function"
        ) {
          window.quickAddModal.close();
        }
        return; // Stop propagation after closing quick-add
      } else if (isCartOpen) {
        closeCartDrawer();
      } else if (activeComponent === "mobile-search") {
        closeMobileSearchDrawer();
      } else if (activeComponent === "menu") {
        toggleMenu();
      } else if (activeComponent === "video-popup") {
        closeVideoPopup();
      } else if (activeComponent === "filter") {
        closeFilterDrawer();
      }
    }
  };

  // Add escape key listener once
  document.addEventListener("keydown", handleEscapeKey);

  // Ensure filter drawer functions are on window (already set above, but ensure activeComponent is set)
  window.openFilterDrawer = openFilterDrawer;
  window.closeFilterDrawer = closeFilterDrawer;

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.activeComponent = activeComponent;
  window.toggleMenu = toggleMenu;

  // Export overlay management functions
  window.setOverlayZIndex = setOverlayZIndex;
  window.resetOverlayZIndex = resetOverlayZIndex;
  window.Z_INDEX = Z_INDEX;

  // Mobile Search Drawer functionality
  const mobileSearchBtn = document.getElementById("mobile-search-btn");
  const mobileSearchDrawer = document.getElementById("mobile-search-drawer");
  const mobileSearchClose = document.getElementById("mobile-search-close");
  const mobileSearchInput = document.querySelector(
    "[data-mobile-search-input]"
  );

  // Open Mobile Search Drawer
  const openMobileSearchDrawer = () => {
    if (!mobileSearchDrawer) return;

    // Close other popups
    if (activeComponent === "cart") closeCartDrawer();
    if (activeComponent === "menu") toggleMenu();

    mobileSearchDrawer.classList.add("active");
    mainOverlay.classList.add("active");

    // Set overlay z-index for mobile search
    setOverlayZIndex(Z_INDEX.MOBILE_SEARCH_OVERLAY);

    // Add overlay click handler
    const overlayClickHandler = (e) => {
      if (e.target === mainOverlay) {
        closeMobileSearchDrawer();
      }
    };
    mainOverlay.addEventListener("click", overlayClickHandler);

    // Store handler for cleanup
    mobileSearchDrawer._overlayHandler = overlayClickHandler;

    document.body.style.overflow = "hidden";
    activeComponent = "mobile-search";

    // Focus search input
    if (mobileSearchInput) {
      setTimeout(() => {
        mobileSearchInput.focus();
      }, 100);
    }
  };

  // Close Mobile Search Drawer
  const closeMobileSearchDrawer = () => {
    if (!mobileSearchDrawer || !mobileSearchDrawer.classList.contains("active"))
      return;

    mobileSearchDrawer.classList.remove("active");
    mainOverlay.classList.remove("active");
    resetOverlayZIndex();

    // Remove overlay click handler
    if (mobileSearchDrawer._overlayHandler) {
      mainOverlay.removeEventListener(
        "click",
        mobileSearchDrawer._overlayHandler
      );
      mobileSearchDrawer._overlayHandler = null;
    }

    document.body.style.overflow = "";
    activeComponent = null;
  };

  // Event listeners
  if (mobileSearchBtn) {
    mobileSearchBtn.addEventListener("click", openMobileSearchDrawer);
  }

  if (mobileSearchClose) {
    mobileSearchClose.addEventListener("click", closeMobileSearchDrawer);
  }

  // Make functions available globally
  window.openMobileSearchDrawer = openMobileSearchDrawer;
  window.closeMobileSearchDrawer = closeMobileSearchDrawer;

  // ============================================================================
  // LOCALIZATION TOGGLE
  // ============================================================================
  const localizationButton = document.getElementById("localization-button");
  if (localizationButton) {
    localizationButton.addEventListener("click", function (e) {
      e.preventDefault();

      // Get current locale from data attribute
      const currentLocale = localizationButton.dataset.currentLocale;
      if (!currentLocale) {
        console.error("Current locale not found");
        return;
      }

      // Determine target locale (toggle between 'ar' and 'en')
      const targetLocale = currentLocale === "ar" ? "en" : "ar";

      // Get available language codes from data attribute
      let availableLanguageCodes = [];
      try {
        availableLanguageCodes = JSON.parse(
          localizationButton.dataset.availableLanguages || "[]"
        );
      } catch (error) {
        console.error("Error parsing available languages:", error);
        // Fallback to common languages
        availableLanguageCodes = ["ar", "en"];
      }

      // Verify target locale is available
      if (!availableLanguageCodes.includes(targetLocale)) {
        console.error("Target language not available");
        return;
      }

      // Get current URL
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);

      // Get the current path without locale
      const pathParts = url.pathname.split("/").filter((part) => part);

      // Remove current locale if it's the first part (ar or en)
      if (
        pathParts.length > 0 &&
        (pathParts[0] === currentLocale ||
          pathParts[0] === "ar" ||
          pathParts[0] === "en")
      ) {
        pathParts.shift();
      }

      // For English (default), don't add locale prefix
      // For Arabic, add /ar/ prefix
      if (targetLocale === "ar") {
        pathParts.unshift(targetLocale);
      }
      // If targetLocale is "en", don't add any prefix (English is default)

      url.pathname = "/" + pathParts.join("/");

      // Preserve query parameters
      const newUrl = url.toString();

      // Redirect to new URL
      window.location.href = newUrl;
    });
  }
});
